import type { ModuleDefinition } from '../types';

export const schedulingModule: ModuleDefinition = {
  key: 'scheduling',
  milestone: 'M11',
  network: { path: 'scheduling', permission: 'capacity.manage.network', labelKey: 'scheduling' },
  tenant: { path: 'scheduling', permission: 'calendar.read', labelKey: 'scheduling' },
  load: () => import('./SchedulingModule'),
};
